import { render, staticRenderFns } from "./Finish.vue?vue&type=template&id=768c65a4&scoped=true&"
var script = {}
import style0 from "./Finish.vue?vue&type=style&index=0&id=768c65a4&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768c65a4",
  null
  
)

export default component.exports